import { Inject, Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { WalletAction } from "@obg/ngx.core";
import { EventBusFacade } from "remote-module-context";
import { map } from "rxjs/operators";

import { T_SHELL_EVENT_BUS_FACADE } from "../injection";
import { observeEvent } from "../util/observe-event";

@Injectable({
	providedIn: "root",
})
export class WalletEffects {
	fetchBalance$ = createEffect(() =>
		observeEvent<void>(this.eventBus, "fetchBalance").pipe(map(() => this.walletAction.getBalance()))
	);

	constructor(
		@Inject(T_SHELL_EVENT_BUS_FACADE) private eventBus: EventBusFacade,
		private walletAction: WalletAction
	) {}
}
